import { createReduxConstants } from '@bibliocommons/utils-redux';

export default createReduxConstants('BROWSE', {
  FETCH_BROWSE_REQUEST: null,
  FETCH_BROWSE_SUCCESS: null,
  FETCH_BROWSE_FAILURE: null
});
